import { z } from 'zod';

export const CoreUnreadItemScalarFieldEnumSchema = z.enum(['id','cityId','rowTimestamp','entityType','entityId','userId','deviceToken']);

export default CoreUnreadItemScalarFieldEnumSchema;
